<script setup lang="ts">
import type { RouteLocationRaw } from '#vue-router'
import { NuxtLink } from '#components'

defineProps<{
  links: Array<{
    label: string | undefined | null
    url?: RouteLocationRaw
    education?: string | undefined | null
  }>
}>()
</script>

<template>
  <div class="flex flex-col gap-[10px]">
    <div v-for="(link, index) in links" :key="index" class="flex flex-col gap-2xs">
      <component
        :is="link.url ? NuxtLink : 'span'"
        v-if="link.label"
        :to="link.url"
        class="text-xsmall"
        :class="link.url ? 'underline' : 'no-underline cursor-default'"
      >
        {{ link.label }}
      </component>
      <span v-if="link.education" class="text-caption italic">
        {{ link.education }}
      </span>
    </div>
  </div>
</template>
